/**
 * Images
 */
const imageContext = require.context('./img', false, /^\.\/.*\.(jpg|jpeg|png|gif)$/);
const images = {};
imageContext.keys().forEach((key) => {
  images[key.match(/^\.\/(.*\.(jpg|jpeg|png|gif))$/)[1]] = imageContext(key);
});

/**
 * Backgrounds images
 */
const bgContext = require.context('./img/backgrounds', false, /^\.\/.*\.(jpg|jpeg|png|gif)$/);
const backgrounds = {};
bgContext.keys().forEach((key) => {
  backgrounds[key.match(/^\.\/(.*\.(jpg|jpeg|png|gif))$/)[1]] = bgContext(key);
});

/**
 * Defaults images
 */
const defaultContext = require.context('./img/defaults', false, /^\.\/.*\.(jpg|jpeg|png|gif|svg)$/);
const defaults = {};
defaultContext.keys().forEach((key) => {
  defaults[key.match(/^\.\/(.*\.(jpg|jpeg|png|gif|svg))$/)[1]] = defaultContext(key);
});

/**
 * Svgs
 */
const svgContext = require.context('./svg', false, /^\.\/.*\.svg$/);
const svgs = {};
svgContext.keys().forEach((key) => {
  svgs[key.match(/^\.\/(.*)\.svg$/)[1]] = svgContext(key);
});

/**
 * Avatar svgs
 */
const avatarContext = require.context('./svg/avatars', false, /^\.\/.*\.svg$/);
const avatars = {};
avatarContext.keys().forEach((key) => {
  avatars[key.match(/^\.\/(.*)\.svg$/)[1]] = avatarContext(key);
});

/**
 * Pdfs
 */
const pdfContext = require.context('./pdf', false, /^\.\/.*\.pdf$/);
const pdfs = {};
pdfContext.keys().forEach((key) => {
  pdfs[key.match(/^\.\/(.*)\.pdf$/)[1]] = pdfContext(key).default;
});

/**
 * Certificate  pdf
 */
const certificatePdfContext = require.context('./pdf', false, /^\.\/HUB_Certificate_Updated_2020\.pdf$/);
const certificatePaths = {};
certificatePdfContext.keys().forEach((key) => {
  certificatePaths[key.match(/^\.\/(.*)\.pdf$/)[1]] = certificatePdfContext(key).default;
});

/**
 * Media
 */
const mediaContext = require.context('./media', false);
const medias = {};
mediaContext.keys().forEach((key) => {
  medias[key.match(/^\.\/(.*\.[a-zA-Z0-9]{2,5})$/)[1]] = mediaContext(key);
});

export default {
  image: {
    ...images,
    background: backgrounds,
    default: defaults,
  },

  svg: {
    ...svgs,
    avatar: avatars,
  },

  pdf: {
    ...pdfs,
    certificate: certificatePaths,
  },

  media: {
    ...medias,
  },
};
